
import { Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import NavBar from "@/components/navBar.vue";
import Choice from "./Config/choice.vue";
import { orderTradePay, hpay } from "@/req/pay";
import { place } from "@/req/order";
import { list } from "@/req/game";
import { isWechat, isQQ } from "@/utils/config";
@Component({
  components: {
    NavBar,
    Choice,
  },
})
export default class Logout extends Vue {
  public headtitle = "确认订单";
  public roleName = "";
  public count = 0;
  public isLoading = false;
  public xuanz = false;
  public payMentId = null;
  public obj: any = {};
  public disabled = false;
  public orderId: any = "";
  public list = [];
  public recommendActive = null;
  public AlipayStatus = false;
  public WeChatStatus = false;
  public async payNow() {
    if (this.recommendActive == null && this.obj.type == 2) {
      return Toast.fail("请选择收货角色");
    }
    if (this.payMentId == null) {
      return Toast.fail("请选择支付方式");
    }
    this.disabled = true;
    if (this.obj.type == 2) {
      this.getPlace(); // 金币交易
    } else {
      this.getOrder(this.orderId); // 角色交易
    }
  }

  public async getPlace() {
    const res = await place({
      commodity_id: this.obj.id,
      account: this.$store.state.user.info.account,
      role_id: this.obj.type == 2 ? this.recommendActive : "",
      server_id: this.obj.server_id,
    });
    if (res.code === 200) {
      this.getOrder(res.data.order_id);
    } else {
      Toast.fail(res.msg);
    }
    this.disabled = false;
  }

  public async getOrder(val) {
    if (this.payMentId == 1) {
      const res = await orderTradePay({
        order_id: val,
      });
      if (res.code === 200) {
        this.refresh();
      } else {
        Toast.fail(res.msg);
      }
      this.disabled = false;
    } else {
      this.getPay(this.payMentId, val);
    }
  }

  // 支付宝微信支付
  public async getPay(val, order) {
    const sign = `order_id=${order}&pay_type=${
      val == 0 ? "1" : "2"
    }&token=${this.$fn.cookies.getToken("token")}`;
    const windowUrl = `${this.$HTTP_API.pay.hpay}?${sign}`;
    // window.open(windowUrl);
    // this.$fn.sendUrl(windowUrl);
    (window as any).sendUrl(windowUrl);
  }

  public refresh() {
    const toast = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "成功支付，3秒后跳回首页",
    });

    let second = 3;
    const timer = setInterval(() => {
      second--;
      if (second) {
        toast.message = `成功支付，${second}秒后跳回首页`;
      } else {
        clearInterval(timer);
        // 手动清除 Toast
        Toast.clear();
        this.$router.push({ path: "/home" });
      }
    }, 1000);
  }

  public payMent(val) {
    this.payMentId = val;
  }
  public created() {
    // 微信浏览器不显示支付宝支付
    if (isWechat()) {
      this.AlipayStatus = true;
    } else if (isQQ()) {
      // QQ览器不显示微信支付与支付宝支付
      this.AlipayStatus = this.WeChatStatus = true;
    }
    const obj: any = this.$route.query.obj;
    this.obj = JSON.parse(obj);
    if (this.obj.type == 2) {
      this.getListImg();
    } else {
      this.orderId = this.$route.query.orderId;
    }
  }
  public async getListImg() {
    const res = await list({
      server_id: this.obj.server_id,
    });
    if (res.code === 200) {
      this.list = res.data;
    }
    if (this.list.length === 0) {
      this.roleName = "该区暂无角色";
    }
  }
  // 选择角色
  public getActive(val) {
    this.recommendActive = val;
  }
}
